export const actionTypes = {
    FETCH_STORE_INVENTORY: 'FETCH_STORE_INVENTORY',
    FETCH_STORE_INVENTORY_SUCCESS: 'FETCH_STORE_INVENTORY_SUCCESS',
    FETCH_STORE_INVENTORY_FAILED: 'FETCH_STORE_INVENTORY_FAILED',
}